module.exports = __webpack_public_path__ + "img/workshop.43710ea2.png";